import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Tag, TagType } from 'app/shared/models/class/tags/tag';
import { DataService } from 'app/shared/services/data/data.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-mat-accordion-tree',
  templateUrl: './mat-accordion-tree.component.html',
  styleUrls: ['./mat-accordion-tree.component.scss']
})
export class MatAccordionTreeComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() tags: TagType;

  @Input() allComplete = false;
  panelOpenState = false;
  color: ThemePalette = 'primary';
  tagsSelected: Tag[];

  constructor(
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  updateAllComplete() {
    this.allComplete = this.tags.tags != null && this.tags.tags.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.tags.tags == null) { return false; }

    return this.tags.tags.filter(t => t.completed).length > 0 && !this.allComplete;
  }

  setAll(completed: boolean) {
    this.allComplete = completed;
    this.addOrDeleteAllTag();

    if (this.tags.tags == null) { return; }

    this.tags.tags.forEach(t => t.completed = completed);
  }

  addOrDeleteTag(tag: Tag) {
    const index = this.tagsSelected.findIndex(t => t.tagKey === tag.tagKey);

    index !== -1 ?
      this.tagsSelected.splice(index, 1) :
      this.tagsSelected.push(tag);

    this.dataService.tagSelectedAddOffer.next(this.tagsSelected);
  }

  addOrDeleteAllTag(): void {
    let count = 0;

    this.tags.tags.forEach(t => {
      const index = this.tagsSelected?.findIndex(item => item.tagKey === t.tagKey);
      if (index !== -1) { count++; }
    });

    if (count < this.tags.tags.length) {
      this.tags.tags.forEach(t => {
        const index = this.tagsSelected.findIndex(item => item.tagKey === t.tagKey);
        if (index === -1) { this.tagsSelected.push(t); count++; }
      });
    } else if (count === this.tags.tags.length) {
      this.tags.tags.forEach(t => {
        const index = this.tagsSelected.findIndex(item => item.tagKey === t.tagKey);
        this.tagsSelected.splice(index, 1);
      });
    }

    this.dataService.tagSelectedAddOffer.next(this.tagsSelected);
  }

  private isCompleted(): void {
    let count = 0;
    this.tags.tags.forEach(t => {
      this.tagsSelected?.forEach(tS => {
        if (t.tagKey === tS.tagKey) {
          count++;
        }
      });
    });

    this.allComplete = count === this.tags.tags.length ? true : false;
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.tagSelectedAddOffer.asObservable().subscribe({
          next: tagsSelected => {
            this.tagsSelected = tagsSelected;
            this.cdr.detectChanges();
            this.isCompleted();
          }
        })
      );
  }
}
